import { Component, EventEmitter, Output, ViewEncapsulation, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { EstablishmentsService, CreateEstablishmentPayload } from '../../core/services/establishments.service';
import { ToastService } from '../../core/services/toast.service';
import { SupportService } from '../../core/services/support.service';

@Component({
  selector: 'app-estab-create-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './estab-create-modal.component.html',
  styleUrls: ['./estab-create-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None, // réutilise les styles globaux de la modale Compte
})
export class EstabCreateModalComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    document.body.classList.add('modal-open');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
  }
  @Output() close   = new EventEmitter<void>();
  /** ⬅️ on émet aussi le name pour l’afficher tout de suite dans le sélecteur */
  @Output() created = new EventEmitter<{ id: string; name?: string }>();

  private fb  = inject(FormBuilder);
  private api = inject(EstablishmentsService);
  private toastService = inject(ToastService);
  private supportService = inject(SupportService);
  private translate = inject(TranslateService);

  loading = false;

  form = this.fb.nonNullable.group({
    name:    ['', Validators.required],
    address: [''],
    tz:      ['Europe/Paris', Validators.required],
  });

  submit(): void {
    if (this.loading || this.form.invalid) return;
    this.loading = true;

    const raw = this.form.getRawValue();
    const payload: CreateEstablishmentPayload = {
      name: (raw.name ?? '').trim(),
      address: (raw.address ?? '').trim() || null,
      tz: raw.tz ?? 'Europe/Paris',
    };

    this.api.createEstablishment(payload).subscribe({
      next: (res: { id?: string } | any) => {
        const id = (res?.id || res?.establishment_id || '').toString();
        if (id) {
          this.created.emit({ id, name: payload.name });
        }
        this.close.emit();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        const isAccessDenied = err?.status === 403 || 
                               err?.error?.error === 'access_denied' ||
                               (err?.error?.message && err.error.message.toLowerCase().includes('administrateur'));
        if (isAccessDenied) {
          this.close.emit();
          setTimeout(() => {
            const event = new CustomEvent('showEstabContactModal');
            window.dispatchEvent(event);
          }, 100);
        } else {
          let title = err?.error?.title || this.translate.instant('componentsWizard.estabCreate.errorTitleDefault');
          const message = err?.error?.message || this.translate.instant('componentsWizard.estabCreate.errorMessageDefault');
          this.toastService.show(title, 'error', 5000, message);
        }
      },
    });
  }

  onClose(): void {
    if (!this.loading) this.close.emit();
  }
}
